import { Navigate, Outlet, useMatch, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api, type MeResponse } from '../api/client'
import { isSwitchedOn, sectionForPath } from '../lib/sections'
import { SwitchedOffNotice } from './SwitchedOffNotice'
import { TitleTabs } from './TitleTabs'
import { EditorialTitleContext } from './titleContext'
import { deskHref } from './links'

function NoTitles() {
  return (
    <div className="p-8">
      <div className="label mb-1">Editorial Desk</div>
      <p className="text-paper-dim">No titles are assigned to this account. Ask an admin to tick one on the Users page.</p>
    </div>
  )
}

/** Layout for /editorial/:path: resolves and gates the title, then tabs + the page. */
export function EditorialTitle() {
  const { path } = useParams()
  const { data: me } = useQuery<MeResponse>({ queryKey: ['me'], queryFn: () => api.get<MeResponse>('/api/me'), staleTime: 60_000, retry: false })
  const section = sectionForPath(me?.sections ?? [], path)
  // The piece editor has its own full-width frame; every other tab sits in the padded column.
  const fullBleed = useMatch('/editorial/:path/pieces/:id') !== null
  if (!me) return null
  if (!section) {
    if (path === 'none' && (me.sections ?? []).length === 0) return <NoTitles />
    return <Navigate to="/editorial" replace />
  }
  return (
    <EditorialTitleContext.Provider key={section.slug} value={{ section, publicationSlug: section.slug }}>
      {fullBleed ? (
        <>
          {!isSwitchedOn(section) && <div className="px-4 pt-6 sm:px-8"><SwitchedOffNotice section={section.label} /></div>}
          <Outlet />
        </>
      ) : (
        <div className="mx-auto max-w-[1180px] px-4 py-6 sm:px-8">
          <TitleTabs basePath={deskHref(section.path)} publicationSlug={section.slug} />
          {!isSwitchedOn(section) && <SwitchedOffNotice section={section.label} />}
          <Outlet />
        </div>
      )}
    </EditorialTitleContext.Provider>
  )
}
